module.exports = __webpack_public_path__ + "static/home-malaysia-ebdda72b9d8a929a1ae50252ba838f11.jpg";